import React from "react";
import { ESTADOS, MIN_RIESGO } from "./statusHelper";

const tileLabel = {
  fontSize: "10.5px",
  letterSpacing: ".06em",
  textTransform: "uppercase",
  color: "#777a89",
  fontWeight: 600,
};

const tile = {
  background: "#f7f9fb",
  border: "1px solid #e9ebec",
  borderRadius: "8px",
  padding: "11px 14px",
};

const Dot = ({ color, size = 8 }) => (
  <span style={{ width: size, height: size, borderRadius: "50%", background: color, display: "inline-block", flex: "none" }} />
);

const LEYENDA = [
  ["ade", "Adelantadas"],
  ["tie", "En tiempo"],
  ["rie", "En riesgo"],
  ["que", "Quemadas"],
];

const SummaryBar = ({ totals }) => {
  const { counts, widths } = totals;

  return (
    <div className="salidas-status-summary">
      <div style={{ ...tile, flex: "1 1 140px" }}>
        <div style={tileLabel}>Salidas activas</div>
        <div style={{ fontSize: "26px", fontWeight: 600, lineHeight: 1.15, marginTop: "2px" }}>{totals.act}</div>
        {counts.sin > 0 && (
          <div style={{ fontSize: "11px", color: "#777a89" }}>{counts.sin} sin lectura</div>
        )}
      </div>

      <div style={{ ...tile, flex: "2.6 1 380px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
        <div className="d-flex justify-content-between align-items-baseline flex-wrap gap-2">
          <span style={tileLabel}>Cumplimiento de horario</span>
          <span style={{ fontSize: "11.5px", color: "#777a89" }}>{totals.pct} en tiempo o mejor</span>
        </div>
        <div style={{ display: "flex", height: "12px", borderRadius: "3px", overflow: "hidden", margin: "8px 0 7px", background: "#eff2f7" }}>
          {LEYENDA.map(([k]) => (
            <div key={k} style={{ width: widths[k], background: ESTADOS[k].color }} />
          ))}
        </div>
        <div className="d-flex flex-wrap" style={{ columnGap: "20px", rowGap: "4px" }}>
          {LEYENDA.map(([k, label]) => (
            <span key={k} className="d-flex align-items-center" style={{ gap: "6px", fontSize: "11.5px" }}>
              <Dot color={ESTADOS[k].color} />
              {label} <b>{counts[k]}</b>
            </span>
          ))}
        </div>
      </div>

      <div style={{ ...tile, flex: "1.5 1 240px", background: "#fee8e9", borderColor: "#fcc2c5" }}>
        <div style={{ ...tileLabel, color: "#8c3b41" }}>Atención inmediata</div>
        <div style={{ fontSize: "12px", lineHeight: 1.5, marginTop: "4px", color: "#3a2225" }}>{totals.atencion}</div>
      </div>

      <div style={{ ...tile, flex: "1.1 1 200px" }}>
        <div style={tileLabel}>Escala</div>
        <div style={{ fontSize: "10.5px", lineHeight: 1.6, color: "#495057", marginTop: "3px" }}>
          <div>≥{MIN_RIESGO} min antes · adelantada</div>
          <div>±{MIN_RIESGO - 1} min · en tiempo</div>
          <div>{MIN_RIESGO} min tarde hasta la tolerancia · en riesgo</div>
          <div>&gt; tolerancia del punto · quemada</div>
        </div>
      </div>
    </div>
  );
};

export default SummaryBar;
